import styled from "styled-components";


export const Footer = styled.footer` 
    
    text-align: center;
    border-top: 1px solid #fff;
    padding-top: 15px;

    p{
        margin-bottom: 10px;
    }


`